import React from 'react'
import { AuthWrapper } from '../../components'
import { HomePrivate } from './HomePrivate'
import { HomePublic } from './HomePublic'

export const Home = () => <AuthWrapper publicComponent={<HomePublic />} privateComponent={<HomePrivate />} />
